module.exports = __webpack_public_path__ + "exljbris_-_museosans-700italic-webfont.fa63db00637b664ba88b.woff";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/exljbris_-_museosans-700italic-webfont.woff
// module id = ../../../../../src/assets/fonts/exljbris_-_museosans-700italic-webfont.woff
// module chunks = styles